import { useEffect } from 'react'
import { useAppStore } from 'Store/App'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuthStore } from 'Store/Auth'
import { shallow } from 'zustand/shallow'

export function SSOAuthCallback() {
	const location = useLocation()
	const navigate = useNavigate()
	const { setCookieAccessToken, setCookieRefreshToken } = useAuthStore(
		state => ({
			setCookieAccessToken: state.setCookieAccessToken,
			setCookieRefreshToken: state.setCookieRefreshToken,
		}),
		shallow
	)

	const prevPage = useAppStore(state => state.prevPage, shallow)

	// Assuming the tokens are in the query parameters
	useEffect(() => {
		const searchParams = new URLSearchParams(location.search)
		const accessToken = searchParams.get('accessToken')
		const refreshToken = searchParams.get('refreshToken')

		if (accessToken && refreshToken) {
			setCookieAccessToken(accessToken)
			setCookieRefreshToken(refreshToken)

			setTimeout(() => {
				navigate(prevPage || '/', { replace: true }) // Redirect to previous page or home if prevPage is not set
			}, 300)
		} else {
			// Handle error case here
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location, prevPage])

	return <></>
}
